import React from "react";
import { formatManagerName } from "../../utils/subscriptionAlertUtils";

const truncateText = (text, maxLen) => {
  if (!text || text.length <= maxLen) {
    return text ?? "";
  }
  return `${text.slice(0, maxLen)}...`;
};

const ItemCompany = ({ company }) => {
  const companyName = company.name_company ?? "";
  const nameLimit = window.innerWidth < 460 ? 30 : 50;
  const displayName = truncateText(companyName, nameLimit);

  const addressRaw = company.address_company ?? "";
  const displayAddress =
    addressRaw.length < 90 ? addressRaw : `${addressRaw.slice(0, 90)} ........`;

  const manager = formatManagerName(company.manager);
  const supportManager = formatManagerName(company.support_manager);

  return (
    <>
      <span className="reports-cell" title={companyName}>
        {displayName}
      </span>
      <span className="reports-cell company-card-v4-mono">
        {company.inn}
      </span>
      <span className="reports-cell" title={addressRaw}>
        {displayAddress}
      </span>
      <span
        className={`reports-cell${manager.muted ? " reports-cell-muted" : ""}`}
        title={manager.text}
      >
        {manager.text}
      </span>
      <span
        className={`reports-cell${supportManager.muted ? " reports-cell-muted" : ""}`}
        title={supportManager.text}
      >
        {supportManager.text}
      </span>
    </>
  );
};

export default ItemCompany;
